<template>
  <div style="margin-bottom: 30px">
    <div class="container hidden-xs">
      <b-breadcrumbs :items="breadcrumbs" />
    </div>
    <delete-modal
      :show-modal="showDeleteModal"
      :details="currentItem"
      @closeDeleteModal="hideDeleteModal"
      @delete="deleteItem"
    />
    <edit-modal
      :show-modal="showEditModal"
      :details="currentItem"
      @closeEditModal="hideEditModal"
      @edit="editItem"
    />
    <section class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h1>Clients</h1>
          <div class="page-summary-container">
            <div class="page-summary-text">Add, edit & delete clients</div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="input-group">
                <input
                  v-model="clientSearchTerm"
                  type="text"
                  class="form-control"
                  style="height: 40.25px"
                  placeholder="Search clients"
                  @keyup.enter="searchClients"
                />
                <span class="input-group-btn">
                  <b-btn
                    class="btn-primary"
                    style="height: 40.25px"
                    @click="searchClients"
                  >
                    <i class="material-icons">search</i>
                  </b-btn>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="input-group">
                <input
                  v-model="newClient"
                  type="text"
                  class="form-control"
                  :class="{ error: $v.newClient.$error }"
                  style="height: 40.25px"
                  placeholder="Add new client..."
                  @keyup.enter="addClient"
                />
                <span class="input-group-btn">
                  <b-btn
                    class="btn-success"
                    style="height: 40.25px"
                    @click="addClient"
                  >
                    <i class="material-icons">add</i>
                  </b-btn>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <template v-if="loadingClients">
                <div class="container-fluid loading-container">
                  <img
                    class="section-loader"
                    src="@/assets/images/fse_reg-section-loader-admin.gif"
                  />
                </div>
              </template>
              <template v-else-if="clients && clients.length > 0">
                <div
                  v-for="client in clients"
                  :key="'c' + client.id"
                  class="list-container list-container-notifications"
                >
                  <div class="row">
                    <div class="col-xs-9">
                      <span class="label label-success">{{ client.name }}</span>
                    </div>
                    <div class="col-xs-3">
                      <b-dropdown
                        class="btn-group pull-right"
                        :menu-right="true"
                      >
                        <b-btn class="btn btn-primary btn-sm dropdown-toggle">
                          Actions
                          <span class="form-label sr-only"
                            >Toggle Dropdown</span
                          >
                        </b-btn>
                        <template slot="dropdown">
                          <li>
                            <a
                              @click="
                                showEditModal = true;
                                setCurrentItem(client, 'client');
                              "
                              role="button"
                              >Edit</a
                            >
                          </li>
                          <li>
                            <a
                              @click="
                                showDeleteModal = true;
                                setCurrentItem(client, 'client');
                              "
                              role="button"
                              >Delete</a
                            >
                          </li>
                        </template>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <h2>No clients found</h2>
              </template>
              <div class="row">
                <div class="col-xs-12">
                  <div class="pagination-container">
                    <b-pagination
                      v-if="clientPagination && clientPagination.totalPages > 1"
                      v-model="clientPagination.page"
                      :total-page="clientPagination.totalPages"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6">
          <h1>Countries</h1>
          <div class="page-summary-container">
            <div class="page-summary-text">Add, edit & delete countries</div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="input-group">
                <input
                  v-model="regionSearchTerm"
                  type="text"
                  class="form-control"
                  style="height: 40.25px"
                  placeholder="Search countries"
                  @keyup.enter="searchRegions"
                />
                <span class="input-group-btn">
                  <b-btn class="btn-primary" @click="searchRegions">
                    <i class="material-icons">search</i>
                  </b-btn>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="input-group">
                <input
                  v-model="newRegion"
                  type="text"
                  class="form-control"
                  :class="{ error: $v.newRegion.$error }"
                  style="height: 40.25px"
                  placeholder="Add new country..."
                  @keyup.enter="addRegion"
                />
                <span class="input-group-btn">
                  <b-btn class="btn-info" @click="addRegion">
                    <i class="material-icons">add</i>
                  </b-btn>
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <template v-if="loadingRegions">
                <div class="container-fluid loading-container">
                  <img
                    class="section-loader"
                    src="@/assets/images/fse_reg-section-loader-admin.gif"
                  />
                </div>
              </template>
              <template v-else-if="regions && regions.length > 0">
                <div
                  v-for="region in regions"
                  :key="'r' + region.id"
                  class="list-container list-container-notifications"
                >
                  <div class="row">
                    <div class="col-xs-9">
                      <span class="label label-info">{{ region.name }}</span>
                    </div>
                    <div class="col-xs-3">
                      <b-dropdown
                        class="btn-group pull-right"
                        :menu-right="true"
                      >
                        <b-btn class="btn btn-primary btn-sm dropdown-toggle">
                          Actions
                          <span class="form-label sr-only"
                            >Toggle Dropdown</span
                          >
                        </b-btn>
                        <template slot="dropdown">
                          <li>
                            <a
                              @click="
                                showEditModal = true;
                                setCurrentItem(region, 'region');
                              "
                              role="button"
                              >Edit</a
                            >
                          </li>
                          <li>
                            <a
                              @click="
                                showDeleteModal = true;
                                setCurrentItem(region, 'region');
                              "
                              role="button"
                              >Delete</a
                            >
                          </li>
                        </template>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <h2>No regions found</h2>
              </template>
              <div class="row">
                <div class="col-xs-12">
                  <div class="pagination-container">
                    <b-pagination
                      v-if="regionPagination && regionPagination.totalPages > 1"
                      v-model="regionPagination.page"
                      :total-page="regionPagination.totalPages"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<style lang="less" scoped>
.input-group {
  margin-bottom: 30px;
}
.error {
  border-color: red;
  color: red;
}
.loading-container {
  text-align: center;
}
.section-loader {
  max-width: 100px;
  height: auto;
}
</style>

<script>
import deleteModal from '@/components/delete-modal';
import editModal from '@/components/edit-modal';
import { Notification } from 'uiv';
import { startCase } from 'lodash/fp';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { determineNextPageOnDelete } from '@/modules/utils';

export default {
	components: { deleteModal, editModal },
	created() {
		this.getTags({ pageSize: 10 });
		this.getClients({ pageSize: 10 });
		this.getRegions({ pageSize: 10 });
	},
	data() {
		return {
			tagSearchTerm: null,
			tags: null,
			tagsPagination: null,
			regionSearchTerm: null,
			regions: null,
			regionPagination: null,
			newRegion: null,
			newTag: null,
			clientSearchTerm: null,
			clients: null,
			clientPagination: null,
			newClient: null,
			showDeleteModal: false,
			showEditModal: false,
			currentItem: {
				id: null,
				name: null,
				type: null,
			},
			options: null,
			loadingTags: false,
			loadingClients: false,
		};
	},
	validations: {
		newTag: { required },
		newRegion: { required },
		newClient: { required },
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		},
	},
	methods: {
		setCurrentItem(data, type) {
			this.currentItem.id = data.id;
			this.currentItem.name = data.name;
			this.currentItem.type = type;
		},
		hideDeleteModal() {
			this.showDeleteModal = false;
		},
		hideEditModal() {
			this.showEditModal = false;
		},
		async searchTags() {
			await this.getTags({ searchTerm: this.tagSearchTerm, page: 1 });
		},
		async searchRegions() {
			await this.getRegions({ searchTerm: this.regionSearchTerm, page: 1 });
		},
		async searchClients() {
			await this.getClients({ searchTerm: this.clientSearchTerm, page: 1 });
		},

		async getTags(params) {
			this.loadingTags = true;
			const {
				data: { data: tags, pagination },
			} = await this.$axios.get('/tag', { params });
			this.$set(this, 'tags', tags);
			this.$set(this, 'tagsPagination', pagination);
			this.loadingTags = false;
		},
		async getRegions(params) {
			this.loadingRegions = true;
			const {
				data: { data: regions, pagination },
			} = await this.$axios.get('/region', { params });
			this.$set(this, 'regions', regions);
			this.$set(this, 'regionPagination', pagination);
			this.loadingRegions = false;
		},
		async getClients(params) {
			this.loadingClients = true;
			const {
				data: { data: clients, pagination },
			} = await this.$axios.get('/client', { params });
			this.$set(this, 'clients', clients);
			this.$set(this, 'clientPagination', pagination);
			this.loadingClients = false;
		},
		async deleteItem(id) {
			await this.$axios.delete(`/${this.currentItem.type}/${id}`);
			// if this is the last item in a page, render the previous page; current page limit is 10
			let tagPage = null;
			let clientPage = null;
			let regionPage = null;
			if (this.currentItem.type === 'tag') {
				tagPage = determineNextPageOnDelete(this.tagsPagination, 10);
			} else if (this.currentItem.type === 'client') {
				clientPage = determineNextPageOnDelete(this.clientPagination, 10);
			} else if (this.currentItem.type === 'region') {
				regionPage = determineNextPageOnDelete(this.regionPagination, 10);
			}

			this.getTags({
				searchTerm: this.tagSearchTerm,
				page: tagPage || this.tagsPagination.page,
			});
			this.getClients({
				searchTerm: this.clientSearchTerm,
				page: clientPage || this.clientPagination.page,
			});
			this.getRegions({
				searchTerm: this.regionSearchTerm,
				page: regionPage || this.regionPagination.page,
			});

			this.hideDeleteModal();
			Notification.notify({
				type: 'danger',
				title: `${startCase(this.currentItem.type)} deleted`,
				content: `Successfully deleted ${this.currentItem.name}.`,
				duration: 10000,
			});
		},
		async addClient() {
			if (this.$v.newClient.$invalid) {
				this.$v.newClient.$touch();
			} else {
				try {
					await this.$axios.post('/client', { name: this.newClient });
					Notification.notify({
						type: 'success',
						title: `${this.newClient} client created successfully.`,
						duration: 10000,
					});
					await this.getClients({
						searchTerm: this.clientSearchTerm,
						page: this.clientPagination.page,
					});

					this.newClient = null;
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create client.',
						content: e.response ? e.response.data.message : '',
						duration: 10000,
					});
				}
			}
		},
		async addRegion() {
			if (this.$v.newRegion.$invalid) {
				this.$v.newRegion.$touch();
			} else {
				try {
					await this.$axios.post('/region', { name: this.newRegion });
					Notification.notify({
						type: 'success',
						title: `${this.newRegion} region created successfully.`,
						duration: 10000,
					});
					await this.getRegions({
						searchTerm: this.regionSearchTerm,
						page: this.regionPagination.page,
					});
					this.newRegion = null;
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create region.',
						content: e.response ? e.response.data.message : '',
						duration: 10000,
					});
				}
			}
		},
		async addTag() {
			if (this.$v.newTag.$invalid) {
				this.$v.newTag.$touch();
			} else {
				try {
					await this.$axios.post('/tag', { name: this.newTag });
					Notification.notify({
						type: 'success',
						title: `${this.newTag} tag created successfully.`,
						duration: 10000,
					});
					await this.getTags({
						searchTerm: this.tagSearchTerm,
						page: this.tagsPagination.page,
					});
					this.newTag = null;
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create tag.',
						content: e.response ? e.response.data.message : '',
						duration: 10000,
					});
				}
			}
		},
		async editItem(id, newValue) {
			try {
				await this.$axios.put(`/${this.currentItem.type}/${id}`, {
					name: newValue.value,
				});
				await this.getTags({
					searchTerm: this.tagSearchTerm,
					page: this.tagsPagination.page,
				});
				await this.getClients({
					searchTerm: this.clientSearchTerm,
					page: this.clientPagination.page,
				});
				await this.getRegions({
					searchTerm: this.regionSearchTerm,
					page: this.regionPagination.page,
				});
				Notification.notify({
					type: 'success',
					title: `${this.currentItem.name} changed to ${newValue.value}.`,
					duration: 10000,
				});
				this.hideEditModal();
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: `Could not edit ${this.currentItem.name}.`,
					content: e.response ? e.response.data.message : '',
					duration: 10000,
				});
			}
		},
	},
	watch: {
		'clientPagination.page': async function clientPageWatcher() {
			await this.getClients({
				searchTerm: this.clientSearchTerm,
				page: this.clientPagination.page,
				pageSize: 10,
			});
		},
		'regionPagination.page': async function regionPageWatcher() {
			await this.getRegions({
				searchTerm: this.regionSearchTerm,
				page: this.regionPagination.page,
				pageSize: 10,
			});
		},
		'tagsPagination.page': async function tagPageWatcher() {
			await this.getTags({
				searchTerm: this.tagSearchTerm,
				page: this.tagsPagination.page,
				pageSize: 10,
			});
		},
	},
};
</script>
